var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5476 19.2825H79.8084C84.7303 19.2825 88.7202 23.2724 88.7202 28.1943V102.237C88.7202 107.158 84.7303 111.148 79.8084 111.148H47.5476C42.6258 111.148 38.6358 107.158 38.6358 102.237V28.1943C38.6358 23.2724 42.6258 19.2825 47.5476 19.2825Z",
    stroke: "#D89F5B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 73.1433 24.0139)",
    fill: "#D89F5B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 67.1431 100.014)",
    fill: "#D89F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2288 97.0331L44.1429 97.014",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1433 25.0139L61.1433 25.0139",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9304 96.2925C19.6596 92.9199 15.3695 88.2194 12.4911 82.6633C9.61278 77.1072 8.24767 70.8913 8.53299 64.6404C8.81831 58.3895 10.744 52.3239 14.1166 47.0531C17.4891 41.7823 22.1897 37.4922 27.7458 34.6138",
    stroke: "#D89F5B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7666 83.9054L25.4201 96.4917L12.8338 97.1451",
    stroke: "#D89F5B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.249 32.0562C108.52 35.4287 112.81 40.1293 115.688 45.6853C118.566 51.2414 119.932 57.4573 119.646 63.7082C119.361 69.9591 117.435 76.0248 114.063 81.2955C110.69 86.5663 105.99 90.8565 100.433 93.7348",
    stroke: "#D89F5B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.413 44.4432L102.759 31.857L115.346 31.2035",
    stroke: "#D89F5B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRotate);
export default __webpack_public_path__ + "static/media/phone-rotate.3b859579e45d76b48163b5e75291e6b8.svg";
export { ForwardRef as ReactComponent };